// extracted by mini-css-extract-plugin
export default {"get_it_now_v2":"Il","place_order_copy":"Jl","next_order_copy":"Kl","title_wrapper":"Ll","get_it_now_row":"Ml","get_it_now_remaining_items":"Nl","get_it_now_remaining_items_mob":"Ol","order_summary":"Pl","additional_items":"Ql","account_content_slider":"Rl","ingredient_carousel":"Sl","ingredient_carouselwrapper":"Tl","account_content_slide":"Ul","account_subscription_section_mob":"Vl","carouselwrapper":"Wl"};
    if(module.hot) {
      // 1730991498574
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  